/* PhoneTabSkeleton — ghost placeholders for the emulated phone's tabs.
 *
 * Used as the Suspense fallback for every lazy phone-tab chunk AND as the
 * data-loading state inside the list tabs. The flex:1 container is the
 * load-bearing part: the old fallback was a bare unstyled div with zero
 * height, so while a chunk loaded the content column collapsed and the iOS
 * tab bar flashed at the TOP of the phone before dropping into place.
 * Shimmer comes from the shared .bp-shimmer class; layout styles live in
 * App.css under .phone-skel-*.
 */
export default function PhoneTabSkeleton({ variant = 'list' }: { variant?: 'list' | 'keypad' }) {
  if (variant === 'keypad') {
    return (
      <div className="phone-skel" aria-hidden="true">
        <div className="phone-skel-display bp-shimmer" />
        <div className="phone-skel-keys">
          {Array.from({ length: 12 }, (_, i) => (
            <div key={i} className="phone-skel-key bp-shimmer" />
          ))}
        </div>
        <div className="phone-skel-call bp-shimmer" />
      </div>
    )
  }
  return (
    <div className="phone-skel" aria-hidden="true">
      {Array.from({ length: 7 }, (_, i) => (
        // Rows fade as they descend — reads as "content arriving", not a wall
        // of grey. Varied line widths avoid the obviously-fake uniform look.
        <div key={i} className="phone-skel-row" style={{ opacity: 1 - i * 0.11 }}>
          <div className="phone-skel-avatar bp-shimmer" />
          <div className="phone-skel-lines">
            <div className="phone-skel-line bp-shimmer" style={{ width: `${72 - (i % 3) * 14}%` }} />
            <div className="phone-skel-line bp-shimmer" style={{ width: `${46 - (i % 2) * 10}%` }} />
          </div>
        </div>
      ))}
    </div>
  )
}
